import __ from "lodash";

import BookingAction from "./BookingAction";
import PlaneTicket from "./PlaneTicket";
import AircraftMaintenance from "./AircraftMaintenance";
import DocumentType from "./DocumentType";
import PushbackTug from "./PushbackTug";
import Nudge from "./Nudge";
import FreighterLoading from "./FreighterLoading";
import FreighterUnloadingX from "./FreighterUnloadingX";
import FreighterUnloading from "./FreighterUnloading";
import WaterCup from "./CupWater";
import TermsConditions from "./TermsConditions";
import PilotIcon from "./Pilot";
import RouteIcon from "./RouteIcon";
import PlaneEnRouteIcon from "./PlaneEnrouteIcon";
import OneWayFlightIcon from "./OneWayFlightIcon";
import ReturnFlightIcon from "./ReturnFlightIcon";
import FlightRouteIcon from "./FlightRouteIcon";
import FlightMidRouteIcon from "./FlightRouteIcon";
import HandshakeIcon from './HandshakeIcon';
import AirplaneClockIcon from './AirplaneClockIcon';
import AirplaneClockCancelIcon from './AirplaneClockCancelIcon';
import AirportIcon from './AirportIcon';
import CalendarClockIcon from './CalendarClockIcon';
import ChartTimelineIcon from './ChartTimelineIcon';
import CheckboxMultipleIcon from './CheckboxMultipleIcon';
import ChecklistIcon from './ChecklistIcon';
import FoodOutlineIcon from './FoodOutlineIcon';
import FoodIcon from './FoodIcon';
import Pilot2Icon from './Pilot2Icon';
import RouteMarkerTickedIcon from './RouteMarkerTickedIcon';
import RouteOndIcon from './RouteOndIcon';
import RoutePathIcon from './RoutePathIcon';
import WorldCheckIcon from './WorldCheckIcon';
import FlightScheduleIcon from './FlightScheduleIcon';
import AirportSlotIcon from './AirportSlotIcon';
import AirCargoIcon from './AirCargoIcon';
import PassengerIcon from './PassengerIcon';
import PassengerSeatIcon from './PassengerSeatIcon';
import AirplaneCheckIcon from './AirplaneCheckIcon';
import AirplaneCogIcon from './AirplaneCogIcon';
import AirplaneEditIcon from './AirplaneEditIcon';
import AirplaneLandingIcon from './AirplaneLandingIcon';
import AirplaneMarkerIcon from './AirplaneMarkerIcon';
import AirplaneSearchIcon from './AirplaneSearchIcon';
import AirplaneTakeoffIcon from './AirplaneTakeoffIcon';
import EarthIcon from './EarthIcon';
import FuelOrderIcon from './FuelOrderIcon';
import ReportsIcon from './ReportsIcon';
import AirCargoInverseIcon from './AirCargoInverseIcon';
import UldContainerIcon from './UldContainerIcon';
import UldContainerClosedIcon from './UldContainerClosedIcon';
import WeightKgIcon from './WeightKgIcon';
import PinIcon from './PinIcon';
import PinOffIcon from './PinOffIcon';
import PinOutlineIcon from './PinOutlineIcon';
import PinOffOutlineIcon from './PinOffOutlineIcon';
import DocumentsIcon from './DocumentsIcon';
import NotesIcon from './NotesIcon';
import AirplaneEventIcon from './AirplaneEventIcon';
import AirplaneNoteIcon from './AirplaneNoteIcon';
import { Icon } from "@material-ui/core";
import CopyItemIcon from './CopyItemIcon';
import MoveItemIcon from './MoveItemIcon';
import AirplaneReturnIcon from './AirplaneReturnIcon';
import AirplaneDiversionIcon from './AirplaneDiversionIcon';
import CalculatorIcon from './CalculatorIcon';
import GroundHandlerIcon from './GroundHandlerIcon';
import ManifestClosed from "./ManifestClosed";
import ManifestOpen from "./ManifestOpen";
import FfmIcon from "./Ffm";
import AviIcon from './AviIcon';
import SlrIcon from './SlrIcon';
import OpenAiIcon from './OpenAiIcon';
import Messages from './Messages';
import AirplaneParkedIcon from './AirplaneParkedIcon';
import AirplaneMxIcon from './AirplaneMxIcon';
import AirplaneEnrouteIcon from './AirplaneEnrouteIcon';

const icons = {
  BookingAction,
  PlaneTicket,
  AircraftMaintenance,
  DocumentType,
  PushbackTug,
  Nudge,
  FreighterLoading,
  FreighterUnloadingX,
  FreighterUnloading,
  WaterCup,
  TermsConditions,
  PilotIcon,
  RouteIcon,
  PlaneEnRouteIcon,
  OneWayFlightIcon,
  ReturnFlightIcon,
  FlightRouteIcon,
  FlightMidRouteIcon,
  HandshakeIcon,
  AirplaneClockIcon,
  AirplaneClockCancelIcon,
  AirportIcon,
  CalendarClockIcon,
  ChartTimelineIcon,
  CheckboxMultipleIcon,
  ChecklistIcon,
  FoodOutlineIcon,
  FoodIcon,
  Pilot2Icon,
  RouteMarkerTickedIcon,
  RouteOndIcon,
  RoutePathIcon,
  WorldCheckIcon,
  FlightScheduleIcon,
  AirportSlotIcon,
  AirCargoIcon,
  AirplaneCheckIcon,
  AirplaneCogIcon,
  AirplaneEditIcon,
  AirplaneLandingIcon,
  AirplaneMarkerIcon,
  AirplaneSearchIcon,
  AirplaneTakeoffIcon,
  AirplaneParkedIcon,
  EarthIcon,
  PassengerIcon,
  PassengerSeatIcon,
  FuelOrderIcon,
  ReportsIcon,
  AirCargoInverseIcon,
  UldContainerIcon,
  UldContainerClosedIcon,
  WeightKgIcon,
  PinIcon,
  PinOffIcon,
  PinOutlineIcon,
  PinOffOutlineIcon,
  DocumentsIcon,
  NotesIcon,
  AirplaneEventIcon,
  AirplaneNoteIcon,
  CopyItemIcon,
  MoveItemIcon,
  AirplaneReturnIcon,
  AirplaneDiversionIcon,
  CalculatorIcon,
  GroundHandlerIcon,
  ManifestClosed,
  ManifestOpen,
  FfmIcon,
  AviIcon,
  SlrIcon,
  OpenAiIcon,
  Messages,
  AirplaneMxIcon,
  AirplaneEnrouteIcon,
}

const Icons = (props) => {
  if (props.children && typeof props.children === 'string' && icons[props.children]) {
    const OurIcon = icons[props.children];
    return (<OurIcon {...__.omit(props, 'children')}/>);
  }
  if (props.children && typeof props.children === 'string' && props.children.substring(0,1) === props.children.substring(0,1).toLowerCase()) {
    return <Icon {...__.omit(props, 'children')}>{props.children}</Icon>;
  }
  return null;
}
export default  Icons;

export {
  BookingAction,
  PlaneTicket,
  AircraftMaintenance,
  DocumentType,
  PushbackTug,
  Nudge,
  FreighterLoading,
  FreighterUnloading,
  FreighterUnloadingX,
  WaterCup,
  TermsConditions,
  PilotIcon,
  RouteIcon,
  PlaneEnRouteIcon,
  OneWayFlightIcon,
  ReturnFlightIcon,
  FlightRouteIcon,
  FlightMidRouteIcon,
  HandshakeIcon,
  AirplaneClockIcon,
  AirportIcon,
  CalendarClockIcon,
  ChartTimelineIcon,
  CheckboxMultipleIcon,
  ChecklistIcon,
  FoodOutlineIcon,
  FoodIcon,
  Pilot2Icon,
  RouteMarkerTickedIcon,
  RouteOndIcon,
  RoutePathIcon,
  WorldCheckIcon,
  FlightScheduleIcon,
  AirportSlotIcon,
  AirCargoIcon,
  AirplaneCheckIcon,
  AirplaneCogIcon,
  AirplaneEditIcon,
  AirplaneLandingIcon,
  AirplaneMarkerIcon,
  AirplaneSearchIcon,
  AirplaneTakeoffIcon,
  EarthIcon,
  PassengerIcon,
  PassengerSeatIcon,
  FuelOrderIcon,
  ReportsIcon,
  AirCargoInverseIcon,
  UldContainerIcon,
  UldContainerClosedIcon,
  WeightKgIcon,
  PinIcon,
  PinOffIcon,
  PinOutlineIcon,
  PinOffOutlineIcon,
  DocumentsIcon,
  NotesIcon,
  AirplaneEventIcon,
  AirplaneNoteIcon,
  CopyItemIcon,
  MoveItemIcon,
  AirplaneReturnIcon,
  AirplaneDiversionIcon,
  CalculatorIcon,
  GroundHandlerIcon,
  ManifestClosed,
  ManifestOpen,
  FfmIcon,
  AviIcon,
  SlrIcon,
  OpenAiIcon,
  Messages,
  AirplaneParkedIcon,
  AirplaneMxIcon,
  AirplaneEnrouteIcon,
}
